import { useQuery } from 'react-query';

import * as geoApi from '@/services/Geo/request';

import { EXPANSION_REQUESTS_QUERY_KEY } from './useExpansionRequest';

// Fica sob o prefixo da fila de propósito: aprovar/recusar invalidam
// `[EXPANSION_REQUESTS_QUERY_KEY]` e a contagem recarrega junto.
export const PENDING_EXPANSION_REQUESTS_COUNT_KEY = [EXPANSION_REQUESTS_QUERY_KEY, 'pending-count'];
// Pedido novo nasce no app da franquia, não nesta tela: a bolinha do menu se
// atualiza sozinha de tempos em tempos e ao voltar pra aba.
export const PENDING_COUNT_REFETCH_MS = 5 * 60 * 1000;

/**
 * Quantos pedidos de ampliação estão em análise (`status=PENDING`) — a
 * bolinha do item "Pedidos de ampliação" no menu. Só o `count` do envelope
 * interessa (`page_size=1`: a página vem quase vazia). `enabled=false` para
 * quem não vê o item — não vale um 403 por sessão. Erro é silencioso, sem o
 * toast padrão do `queryClient`: menu não é lugar de aviso, e sem a contagem
 * a bolinha só não acende.
 */
export function usePendingExpansionRequestsCount({ enabled }: { enabled: boolean }) {
  return useQuery(
    PENDING_EXPANSION_REQUESTS_COUNT_KEY,
    () => geoApi.listExpansionRequests({ status: 'PENDING', page: 1, page_size: 1 }),
    {
      enabled,
      select: (response) => response.count,
      staleTime: 60_000,
      refetchInterval: PENDING_COUNT_REFETCH_MS,
      refetchOnWindowFocus: true,
      onError: () => {},
    },
  );
}
